const drumpadData = [
    {
        innerText: "Q",
        id:"Cymbal-Crash",
        unicode: 81,
        audioLink:"http://www.percussionclinic.com/sounds/instrumentclips/chinacymbal.mp3"
    },
    {
        innerText: "W",
        id:"Hi-Hat",
        unicode: 87,
        audioLink:"http://www.denhaku.com/r_box/sr16/sr16hat/sweethat.wav"
    },
    {
        innerText: "E",
        id:"Cymbal-Ride",
        unicode: 69,
        audioLink:"http://dight310.byu.edu/media/audio/FreeLoops.com/1/1/909%20Ride%2003-5850-Free-Loops.com.mp3"
    },
    {
        innerText: "A",
        id:"Rimshot",
        unicode: 65,
        audioLink:"http://www.randomthink.net/labs/html5drums/drumkit/Rimshot.mp3"
    },
    {
        innerText: "S",
        id:"Snare-1",
        unicode: 83,
        audioLink:"http://www.footdrumplus.ca/uploads/3/4/8/6/34866267/fl6_snarex-.wav"
    },
    {
        innerText: "D",
        id:"Snare-2",
        unicode: 68,
        audioLink:"http://www.denhaku.com/r_box/sr16/sr16sd/batterrm.wav"
    },
    {
        innerText: "Z",
        id:"Tom-Tom-1",
        unicode: 90,
        audioLink:"http://www.denhaku.com/r_box/sr16/sr16tom/locan%20hl.wav"
    },
    {
        innerText: "X",
        id:"Tom-Tom-2",
        unicode: 88,
        audioLink:"http://tipiwiki.free.fr/snd/Tamtam2.wav"
    },
    {
        innerText: "C",
        id:"Bass Drum",
        unicode: 67,
        audioLink:"http://dight310.byu.edu/media/audio/FreeLoops.com/1/1/Bass%20Drum%20Free%20002-1659-Free-Loops.com.mp3"
    }
]

export default drumpadData
